<template>
  <div class="ui segment project-summary" v-if="showTable">
    <div class="summary-title">Logged by project</div>
    <div class="summary-table-wrap">
      <table class="ui very compact small table">
        <thead>
          <tr>
            <th>Project</th>
            <th class="right aligned collapsing" title="Total">All</th>
            <th
              class="right aligned collapsing"
              v-for="col in summary.columns"
              :key="col.key"
              :title="col.label"
            >
              {{ short(col.label) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in summary.projects" :key="p.project">
            <td class="project-name" :title="p.project">{{ p.project }}</td>
            <td class="right aligned collapsing">
              <b>{{ p.total }}</b>
            </td>
            <td
              class="right aligned collapsing"
              v-for="col in summary.columns"
              :key="col.key"
            >
              {{ p[col.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// Panel boczny ma ok. 300px, więc pełne nazwy ról nie mieszczą się w nagłówkach.
const SHORT = {
  "Project owners": "PO",
  Coordinators: "Coord",
  Agents: "Ag",
  Admins: "Adm",
};
export default {
  computed: {
    ...mapGetters(["loggedUsersByProject"]),
    summary() {
      return this.loggedUsersByProject;
    },
    showTable() {
      return this.$store.state.showLoggedIn && this.summary.projects.length > 1;
    },
  },
  methods: {
    short(label) {
      return SHORT[label] || label;
    },
  },
};
</script>

<style scoped>
.project-summary {
  width: calc(100% - 16px);
  padding: 8px 10px;
  margin: 0 8px 12px 8px;
}

.summary-title {
  font-weight: 700;
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}

.summary-table-wrap {
  max-height: 35vh;
  overflow-y: auto;
}

.summary-table-wrap table {
  margin: 0 !important;
  width: 100%;
  font-size: 0.85em;
}

.summary-table-wrap th,
.summary-table-wrap td {
  padding: 4px 5px !important;
}

.project-name {
  overflow-wrap: anywhere;
}
</style>
